<template>
  <div>Modul</div>
</template>

<script>
export default {
  name: 'Modul',
  props: {
    context: {
      type: Object,
    },
  },
};
</script>
